"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Shipping = function Shipping(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size,
      _ref$langContext = _ref.langContext,
      langContext = _ref$langContext === void 0 ? {
    translate: function translate(text) {
      return text;
    }
  } : _ref$langContext,
      translateKey = _ref.translateKey;
  var iconSize = size === 'original' ? 'width="17" height="17"' : 'width="100%"';
  var title;

  if (translateKey) {
    title = translateKey('shipToHome');
  } else {
    title = langContext.translate('Shipping Icon');
  }

  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" ").concat(iconSize, " viewBox=\"0 0 17 17\">\n      <title>").concat(title, "</title>\n      <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(-62.000000, -52.000000)\" fill=\"").concat(color, "\">\n          <path d=\"M70.3113643,52 L62,55.589451 L62,64.7272493 L70.3113643,68.6243911 L78.6243911,64.7272493 L78.6243911,55.589451 L70.3113643,52 L70.3113643,52 Z M70.3565477,53.6624391 L71.9746347,54.3916439 L66.7026131,56.9873173 L64.9092684,56.1307842 L70.3565477,53.6624391 L70.3565477,53.6624391 Z M69.0653662,66.1307325 L63.2468293,63.4987244 L63.2468293,57.4029271 L69.0653662,60.0361554 L69.0653662,66.1307325 L69.0653662,66.1307325 Z M70.3396604,58.2341467 L68.2341467,57.3039297 L73.4662302,54.9092684 L75.7151227,55.8550222 L70.3396604,58.2341467 L70.3396604,58.2341467 Z M76.961952,63.4987244 L71.1434151,66.1307325 L71.1434151,60.0361554 L76.961952,57.4029271 L76.961952,63.4987244 L76.961952,63.4987244 Z M66.9873173,60.5710536 L64.4936587,59.480976 L64.4936587,61.82102 L66.9873173,62.8058542 L66.9873173,60.5710536 L66.9873173,60.5710536 Z\" />\n        </g>\n      </g>\n    </svg>\n  ");
};

var _default = Shipping;
exports["default"] = _default;